import { ChangeEvent, ReactElement, useEffect, useState } from "react";
import Detail from "../../../components/dialogs/detail";
import { IState, IUser } from "../../../types";
import { CircularProgress, Tab, Tabs } from "@mui/material";
import { useSelector } from "react-redux";
import TabPanel from "../../../components/tabPanel";
import Tasks from "./components/tasks";
import { useFetch } from "../../../system/useFetch";
import { IDivision } from "./types";


interface IProps {
  hash: string;
  user: IUser;
  closed: () => void;
}

const TaskDialog = ({ closed, user, hash }: IProps): ReactElement => {
  const [tab, setTab] = useState<number>(0);
  const darkMode = useSelector((state: IState) => state.darkMode);
  const { data } = useFetch<IDivision[]>(
    {
      module: "task",
      query: "getDivisions",
      payload: {
        hash
      }
    });

  useEffect(() => {
    if (data && data.length > 0){
      setTab(data[0].divisionID);
    }
  }, [ data ]);

  const handleTabChange = (_event: ChangeEvent<any>, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Detail closed={closed} title="Tasks" maxWidth="xl" fullWidth={true} fullScreen={true} disabledBackground={true} disableScroll={true}>
      {!data || tab === 0
        ? <div className="display-flex-row align-items-center justify-content-center"><CircularProgress /></div>
        : <>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            centered={true}
            style={{ background: darkMode ? "rgba(255, 255, 255, 0.2)" : "rgba(0, 0, 0, 0.2)" }}>
            {data.map(d => <Tab key={`div-${d.code}`} label={d.name} value={d.divisionID}/>)}
          </Tabs>
          {data.map(d => {

            return(
              <TabPanel key={`div-panel-${d.code}`} value={d.divisionID} index={tab}>
                <Tasks hash={hash} user={user} division={d}/>
              </TabPanel>);
          })}
        </>
      }
    </Detail>
  );
};

export default TaskDialog;